import Box from '@mui/material/Box';
import { Controller, useFormContext } from 'react-hook-form';
import PaymentWidget from 'src/components/PaymentWidget';
import { PaymentFormValues } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2';
import { PaymentSectionId } from 'src/pages/payment-msi/PaymentMsiV2/constants';
import { AppTheme } from 'src/themes/muiTheme';
import { PaymentSection, PaymentSectionHeader } from './PaymentSection';

const paymentOptionSectionStyles = {
  header: (theme: AppTheme) => {
    const mobileMaxSize = theme.breakpoints.values.sm + 1;
    const mobile = theme.breakpoints.down(mobileMaxSize);

    return {
      marginBottom: '24px',
      [mobile]: {
        marginBottom: '30px',
      },
    };
  },
  headerTitle: (theme: AppTheme) => {
    const mobileMaxSize = theme.breakpoints.values.sm + 1;
    const mobile = theme.breakpoints.down(mobileMaxSize);

    return {
      [mobile]: {
        marginBottom: '0px',
      },
    };
  },
  paymentWidgetWrapper: (theme: AppTheme) => {
    const mobileMaxSize = theme.breakpoints.values.sm + 1;
    const tabletMaxSize = theme.breakpoints.values.lg + 1;
    const tablet = theme.breakpoints.between(mobileMaxSize, tabletMaxSize);

    return {
      minHeight: '286px',
      [tablet]: {
        minHeight: '252px',
      },
    };
  },
};

export function PaymentOptionSection() {
  const { control } = useFormContext<PaymentFormValues>();

  return (
    <PaymentSection id={PaymentSectionId.PaymentOption}>
      <PaymentSectionHeader
        headerProps={{ sx: paymentOptionSectionStyles.header }}
        sectionTitleProps={{ sx: paymentOptionSectionStyles.headerTitle }}
        hasSwitch={false}
        sectionTitle={'Choose your payment method'}
      />
      <Box sx={paymentOptionSectionStyles.paymentWidgetWrapper}>
        <Controller
          control={control}
          name="paymentData"
          render={({ field }) => {
            return (
              <PaymentWidget
                onTokenize={(paymentData) => {
                  field.onChange(paymentData);
                }}
              />
            );
          }}
        />
      </Box>
    </PaymentSection>
  );
}
